import AsyncSelect from 'Shared/components/AsyncSelect'
import Select from 'react-select'
import SubscriptionTopicsSelect from 'Shared/components/SubscriptionTopicsSelect'
import SubfilterAsyncSelect from './SubfilterAsyncSelect'
import './FilterParameter.scoped.scss'

function FilterParameter({ id, fields, name }) {
  const act = useAct()
  const { parameters } = useSel((s) => s.rules.entities[id])
  const value = parameters[name]
  const {
    type,
    wider = false,
    widest = false,
    narrower = false,
    spaceBefore = false,
    entity,
    multiple,
    dependsOn,
    loadStaticList,
    queryParameters = {},
    options = [],
  } = fields[name]
  const dependencies = Object.fromEntries(
    (dependsOn || []).map((dependency) => {
      if (typeof dependency === 'object') {
        return [dependency.name, parameters[_.camelCase(dependency.slug)] || null]
      } else {
        return [dependency, parameters[_.camelCase(dependency)] || null]
      }
    })
  )

  const finalQueryParameters = {
    ...queryParameters,
    ...dependencies,
  }

  const updateValue = (value) => act.search.upsertFilterParameters(id, { [name]: value })

  const missingDependency = _.includes(dependencies, null)

  return (
    <div className="parameter">
      {type === 'string' && (
        <input type="text" value={value} onChange={(e) => updateValue(e.target.value)} />
      )}
      {type === 'number' && (
        <input
          style={{ width: narrower ? '80px' : '150px' }}
          type="number"
          value={value}
          onChange={(e) => updateValue(e.target.value)}
        />
      )}
      {type === 'entity' && (
        <AsyncSelect
          entity={entity}
          value={value}
          disabled={missingDependency}
          queryParameters={finalQueryParameters}
          loadStaticList={(dependsOn || []).length > 0 && loadStaticList}
          onChange={updateValue}
          multiple={multiple}
          rootClassName={`root ${wider ? 'wider' : ''}`}
        />
      )}
      {type === 'select' && (
        <div style={{ width: widest ? '400px' : wider ? '250px' : '150px', marginRight: spaceBefore ? '' : '10px', marginLeft: spaceBefore ? '10px' : '' }}>
          <Select
            width={100}
            options={options}
            value={multiple ? 
              (value || []).map(v => options.find(opt => opt.value === v)).filter(Boolean) : 
              _.find(options, { value })
            }
            onChange={(option) => {
              if (multiple) {
                const values = option ? option.map(opt => opt.value) : []
                updateValue(values)
              } else {
                updateValue(option.value)
              }
            }}
            isMulti={multiple}
          />
        </div>
      )}
      {type === 'date' && (
        <input type="date" value={value} onChange={(e) => updateValue(e.target.value)} />
      )}
      {type === 'subscription_topic' && (
        <SubscriptionTopicsSelect
          value={value}
          onChange={(option) => updateValue(option.value)}
        />
      )}
      {type === 'subfilter_entity' && (
        <SubfilterAsyncSelect
          id={id}
          name={name}
          fields={fields}
          onChange={updateValue}
        />
      )}
    </div>
  )
}

export default FilterParameter
